import { useContext, useEffect, useState } from 'react'

import { Box, Button, CheckBox, Modal, Text } from '@fairfashion/design-system'
import Parser from 'html-react-parser'

import { AuthContext } from '../../../../contexts/auth'
import { sdk } from '../../../../services/sdk'

import { ServiceTermsModalProps } from './service-terms-moda.types'
import * as Styles from './service-terms-modal.styles'

export const ServiceTermsModal = ({
  open,
  companyId,
  onClose,
}: ServiceTermsModalProps) => {
  const [checked, setChecked] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState('')
  const [loading, setLoading] = useState(false)

  const { loginBody, authentication, setHeadCompanyTermError } =
    useContext(AuthContext)

  const getTerms = async () => {
    try {
      setLoading(true)
      let response

      if (companyId && loginBody) {
        response = await sdk.settings.getServiceTermsByCompany(
          companyId,
          loginBody,
        )
      } else if (loginBody) {
        response = await sdk.settings.getServiceTerms(loginBody)
      }

      if (response) {
        setData(response.text)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      setError(false)
      setChecked(false)
      getTerms()
    }
  }, [open, companyId])

  const acceptTerms = async (): Promise<void> => {
    if (checked) {
      try {
        if (!loginBody) return

        setLoading(true)
        const response = await sdk.user.acceptServiceTerms(
          {
            email: loginBody.email,
            password: loginBody.password,
          },
          companyId,
        )
        if (response) {
          authentication(loginBody.email, loginBody.password)
          setHeadCompanyTermError(false)
        }
        onClose()
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
  }

  const handleSubmit = () => {
    if (!checked) {
      setError(true)
      return
    }
    acceptTerms()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Termos e condições"
      height="90vh"
      width="800px"
    >
      <Box direction="column" width="100%" style={{ overflow: 'hidden' }}>
        <Styles.Container flex={1} width="100%">
          {loading ? (
            <Box
              height="100%"
              width="100%"
              alignItems="center"
              justifyContent="center"
            >
              <Text>Carregando...</Text>
            </Box>
          ) : (
            <Box width="100%" direction="column" padding={2}>
              {Parser(data)}
            </Box>
          )}
        </Styles.Container>
        <Styles.Footer
          gap={1}
          alignItems="center"
          direction="column"
          width="100%"
          paddingTop={2}
        >
          <CheckBox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            label="Declaro que li e concordo com os termos e condições de uso da plataforma *"
            state={error ? 'error' : 'default'}
            message={error ? 'Você precisa aceitar os termos' : ''}
          />
          <Button width="300px" onClick={handleSubmit}>
            Aceito
          </Button>
        </Styles.Footer>
      </Box>
    </Modal>
  )
}
